import React, { useState, useEffect } from 'react';
import { PubSub } from 'aws-amplify'
import { Container, Switch, Table, ToggleButtonGroup } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Button, { ButtonProps } from '@mui/material/Button';
import  RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'; 
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CardActions from '@mui/material/CardActions';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Typography from "@mui/material/Typography";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ToggleButton from '@mui/material/ToggleButton';
import moment from 'moment'
import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import { API } from '@aws-amplify/api';
import URelay from './urelay';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { CONNECTION_STATE_CHANGE, ConnectionState } from '@aws-amplify/pubsub';
// import { Hub } from 'aws-amplify/utils';
import { Hub } from '@aws-amplify/core';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};



const theme = createTheme({
  palette: {
      primary: {
          main: "#FF0000",
          contrastText: "#ffffff",
      },
      secondary: {
          main: "#808080",
          contrastText: "#ffffff",
      },
      success: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      error: {
        main: "#800000",
        contrastText: "#ffffff",
      },
      active: {
        main: "#800000",
        contrastText: "#ffffff",
      },
      asserted: {
        main: "#ff0000",
        contrastText: "#ffffff",
      },
      notasserted: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      changing: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      green: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      red: {
        main: "#FF0000",
        contrastText: "#ffffff",
      }
  },
});

export default function DeviceView(device) {

  console.log('@DEVICEVIEW prop deviceProp in', device);
  var the_device = device;
  console.log('here in device named', the_device);
  //const handler = switchData.clickHandler;
  ///const relays_io_list = switchData.io.Relays;
  //const gpios_list = switchData.io.GPIOs;
  //console.log('relay list io data', relays_io_list);
  //const relays_config_list = switchData?.config?.Relays;
  //console.log('relay list config data', relays_config_list);
  //const gpios_config_list = switchData?.config?.GPIOs;//

  const typical = {
      id: 1,
      mac: '4091511c44dd',
      name: 'SwitchOne',
      sensors:{Relays: 
        [
        { index: 0, state: 0},
        { index: 1, state: 0}
        ]
      },
      configs: {}
  }


  const typicalSwitchConfig =
  {
    id: 0,
    configs: {
      Device: [
        { mac: '4091511c51cd', name:'defaultDeviceName', model: 'CS-2550' }
      ],
      Relays: [
        { index: 0, type: 1 },
        { index: 1, type: 1 }
      ],
      GPIOs: [
        { index: 0, type: 1 },
        { index: 1, type: 1 }
      ]
    }
  }
  
  //const relay_count = relays_io_list.length;
  //console.log('NUMBER OF RELAYS', relay_count);
  const [isLoading, setisLoading] = useState(0);
  const [mySwitchIO, setMySwitchIO] = useState(typical);
  const [mySwitchConfig, setMySwitchConfig] = useState(typicalSwitchConfig);
  const [messageHistory, setMessageHistory] = useState([]);
  const [mqttConnected, setMqttConnected] = useState(false);
 
  
  function documentSerializer(document) {
    // a.Relays.0.color_assert": 255,
    var device = {'Relays':[], 'GPIOs':[], 'Adcs':[], 'Device':[]};
    var stack_relays = {};
    var stack_gpios = {};
    var stack_adcs = {};
  
    for (const key in document) {
      // pass in an mqtt/aws/sahdow/payload document object with single attribute depth but with encoded.complex keys
      // complex is made up of dot separted attributes...   a.RELAYS.0.state
      // for example attribute.RELAY.position.state
      // single depth is transformed into an object with 4 attributes Relay, GPIO, ADC, Device

      var new_add = {};
      //console.log(`working on key ${key}`);
      var sensor_split = key.split(".");
      var sensor_type = sensor_split[1];
      var sensor_id = parseInt(sensor_split[2]);
      var sensor_attribute = sensor_split[3];
      var sensor_value = document[key];
  
  
      //var somex = device[sensor_type];
      //console.log('device is long', somex.len);
      // is this id already existing ?
      // test.some(function(boy) { return hasValue(boy, "age", 12); }));
  
      //if (e.target.getAttribute('index') === 1)
      
      //var already_exists = device.some(function(this_device) { return hasValue(this_device, "index", sensor_id)})
      //var checkone = device[sensor_type];
      //var checktwo = checkone[0];
      //var c3 = hasKey(checktwo, 'index');
      //var c4 = hasValue(checktwo.index, sensor_id);
  
      //console.log("Serializer:device:jsonString:",JSON.stringify(device));
      var does_index_exist = device[sensor_type].some(function (item, index) {
        //console.log('considering self.inspection', item, sensor_id);
        //console.log('exist in device',JSON.stringify(device));
        var has_index = hasKey(item, 'index');
        var has_value = item['index'] === sensor_id;
        //var has_value2 = hasValue(item, sensor_id);
        if (has_index && has_value) {
          //console.log('index found!');
          return true;
        }
        //console.log('NOT FOUND');
        return false;
      });
  
  

      if (!does_index_exist) {
        device[sensor_type].push({index:sensor_id})
      }
      console.log('bilder vars',does_index_exist, sensor_type, sensor_id, sensor_attribute, sensor_value);
      console.log('device now', JSON.stringify(device));
  
      //var sensor_target = device[sensor_type][sensor_id];
      //var isit = device[sensor_type][0].getAttribute('index');
      //var already_exists = device.some(function(this_device) { return this_device.getAttribute('index') === 0 })
      try {
        console.log('trying to set', `device[${sensor_type}][${sensor_id}][${sensor_attribute}]=${sensor_value}`);
        var already_exists = Object.hasOwn(device[sensor_type][sensor_id], sensor_attribute);
        if (!already_exists) {
          device[sensor_type][sensor_id][sensor_attribute] = sensor_value;
        }
        device[sensor_type][sensor_id][sensor_attribute] = sensor_value;
    } catch (e) { 
      console.log('EEEEEEEEEEEEEEEEE error setting', e); 
    }
      //sensor_target[sensor_attribute] = sensor_value;
  
  
  
  }
  console.log('final device', JSON.stringify(device));
  return device;
  }

  const hasValue = (obj, value) => Object.values(obj).includes(value);
  const hasKey = (obj, key) => Object.keys(obj).includes(key);

  const updateDeviceSensors = (deviceMAC, newDocument) => {
    console.log('XXXXX updating sensor',deviceMAC,newDocument);
    const nextPerson = { ...mySwitchIO, sensors: newDocument };
    setMySwitchIO(nextPerson);
    console.log('da da data now', mySwitchIO);
  }; 

  const updateDeviceConfigs = (deviceMAC, newDocument) => {
    console.log('XXXXX updating config',deviceMAC,newDocument);
    const nextPerson = { ...mySwitchIO, configs: newDocument };
    setMySwitchConfig(nextPerson);
    console.log('nu nu config', mySwitchConfig);
  }; 

  const addMessageEvent = (topic, message) => {
    var old_messages = {...messageHistory};
    old_messages=({topic: message});
    setMessageHistory(old_messages);

  }

  useEffect(() => {
    const loadDeviceInfo = async () => {
      console.log("DEVICEVIEW USE EFFECT");
      setisLoading(1);

      var subscribe_list = []
      var thingName = the_device.device;         
      var topic = "$aws/things/" + thingName + "/shadow/name/io/update/documents";
      subscribe_list.push(topic);
      topic = "$aws/things/" + thingName + "/shadow/name/io/get/accepted";
      subscribe_list.push(topic);

      topic = "$aws/things/" + thingName + "/shadow/name/config/update/documents";
      subscribe_list.push(topic);
      topic = "$aws/things/" + thingName + "/shadow/name/config/get/accepted";
      subscribe_list.push(topic);

      topic = "$aws/things/" + thingName + "/shadow/name/io/update/delta";
      subscribe_list.push(topic);

      var myReflectTopic = "$aws/things/" + thingName + "/shadow/name/io/update";

      console.log('Subscribe List:', subscribe_list);
        //const subscriptionReactListener = PubSub.subscribe(subscribe_topic).subscribe({
      
   
      Hub.listen('pubsub', (data: any) => {
        const { payload } = data;
        if (payload.event === CONNECTION_STATE_CHANGE) {
          const connectionState = payload.data.connectionState;
          console.log(connectionState);
          if (connectionState === ConnectionState.Connected) {
            setMqttConnected(true);
          } 
          else if (connectionState === ConnectionState.Disconnected) {
              setMqttConnected(false);
          }
        } else {
          console.log('UNHANDLED Hub event:', payload);
        }
      }); 

    /*

Connection states
Connected - Connected and working with no issues.
ConnectedPendingDisconnect - The connection has no active subscriptions and is disconnecting.
ConnectedPendingKeepAlive - The connection is open, but has missed expected keep alive messages.
ConnectedPendingNetwork - The connection is open, but the network connection has been disrupted. When the network recovers, the connection will continue serving traffic.
Connecting - Attempting to connect.
ConnectionDisrupted - The connection is disrupted and the network is available.
ConnectionDisruptedPendingNetwork - The connection is disrupted and the network connection is unavailable.
Disconnected - Connection has no active subscriptions and is disconnecting.
    */


      PubSub.subscribe(subscribe_list).subscribe({
      //PubSub.subscribe({ topics: subscribe_topic_list }).subscribe({
      //PubSub.subscribe({ topics: ['$aws/things/4091511c44dd/shadow/get', '$aws/things/4091511c44dd/shadow/get/accepted'] }).subscribe({
        next: (data) => {
            console.log('>>>DDDDDDDD>> MQTT data in..  ',data.value);
            const objectSymbols = Object.getOwnPropertySymbols(data.value);
            var message_topic = data.value[objectSymbols[0]];
            console.log('on topic ', message_topic);
            addMessageEvent(message_topic, data.value);

            var topic_path= message_topic.split("/");
            var topic_channel = topic_path.slice(5)[0]; // io|config
            //var topic_action = topic_path.slice[6][0]; // get|update 
            var message_key = topic_path.slice(-1)[0];
            var message_device = topic_path.slice(2)[0]; //4091511c44dd
            console.log('topic:', message_device, topic_channel, message_key );
            console.log('MQTT message:', data.value);  
            if (topic_channel === "io") {
              if (message_key === "documents") {
                //console.log('data document for device ', message_device);
                console.log('io-data:',data.value);
                const document = data.value.current.state.reported;
                console.log('are you shaping this good ???', document);
                var shaped = documentSerializer(document);
                updateDeviceSensors(message_device,shaped);
                /*
                //console.log('const document now...', document);
                var shaped = documentSerializer(document);
                console.log('data need to set  ', shaped);
                //var switchNowIoD = switchIO;
                var switchNowIoD = {...switchIO, message_device:shaped};
                console.log(':::vallue now', switchNowIoD);
                //setState({...state})
                switchNowIoD[message_device] = shaped;
                setSwitchIO({...switchIO, message_device:shaped });
                
                console.log('showing after switchIO', JSON.stringify(switchIO));
                console.log('showing switchconfig for convenience', JSON.stringify(switchConfig));
                */
              } 
              else if (message_key === "accepted") {
                console.log('processing : io accepted');
                const document = data.value.state.reported;
                console.log('is dist good ???', document);
                shaped = documentSerializer(document);
                updateDeviceSensors(message_device,shaped);
                //updateDeviceSensors(message_device,data.value.state.reported);
                /*
                var shapeda = documentSerializer(document);
                var switchNow = switchIO;
                switchNow[message_device] = shapeda;
                setSwitchIO(switchNow);
                
                console.log('switchIO is now', switchIO);
              */
              }
              else if (message_key === "delta") {
                console.log('>>>>>>>>>>>>>>>>   delta io data', data.value);
                const document = data.value.state;
                var configShaped = documentSerializer(document);
                var msg = {state: {reported: document}};

                console.log(JSON.stringify(msg));

                // dont reply so fast
                new Promise(r => setTimeout(r, 2000));

                var message = msg; //JSON.stringify(msg);
                PubSub.publish(myReflectTopic,message);
                console.log('delta io REFLECTED >>>>>>>>>>')


              }
              else {
                console.log('NOT AN IO/DOCUMENTS/ACCEPTED topic', message_key);
              }
            } 
            else if (topic_channel === "config") {

              if ( message_key === "accepted" ) {
                console.log("config channel data from an accepted", data.value);
                const document = data.value.state.reported;
                var configShaped = documentSerializer(document);
                updateDeviceConfigs(message_device, configShaped);
              } 

              else if (message_key === "documents") {
                console.log('config document shows from config change')
                document = data.value.current.state.reported;
                //var shapedd = documentSerializer(document);
                //console.log('setting CONFIG after shaping is ', shapedd);
                //var switchConfigNowC = switchConfig;
                //switchConfigNowC[message_device] = document;
                //setSwitchConfig(switchConfigNowC);
              }
              //console.log('showing switchConfig', JSON.stringify(switchConfig));
            }
            else {
              console.log('topic channel ', topic_channel, ' not supported yet.');
            }
            console.log('MQTT data done >>>>>>>>>>>>>')
            //setTopicLogging(data);  
          },
          error: (error) => console.error(error),
          complete: () => console.log('Complete done')
      });
      setisLoading(2);
      //await new Promise(r => setTimeout(r, 2000));
      //Now get all the latest io and configs
      //initialGetter(thinglist);        
      var topic_list = [];
      topic = "$aws/things/" + thingName + "/shadow/name/config/get";
      console.log('startup config to get ', topic);
      topic_list.push(topic);
      topic = "$aws/things/" + thingName + "/shadow/name/io/get";
      console.log('startup config to get ', topic);
      topic_list.push(topic);     
      console.log('initial data requesting for these topics:', topic_list);
      var empty_message = "";
      PubSub.publish(topic_list,empty_message);  
      setisLoading(0);
    }
    loadDeviceInfo();
  },[]);

  var relayAtRestIcon = < RadioButtonUncheckedIcon/>
  var device_config = mySwitchConfig?.configs?.Device[0];

  var relays_io_list = mySwitchIO.sensors.Relays;
  var gpios_list = mySwitchIO.sensors.GPIOs;
  var adcs_list = mySwitchIO.sensors.ADCs;

  var relays_config = mySwitchConfig.configs.Relays;
  var gpios_config_list = mySwitchConfig.configs.GPIOs;

  console.log('relays configggged', JSON.stringify(relays_config));
  console.log('relays iod', JSON.stringify(relays_io_list));
 

  const options = ['Configure', 'Delete'];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenuItemClick = (event) => {
  setAnchorEl(event.currentTarget);
  console.log(event.currentTarget);
  const lineItem4 = event.currentTarget;
  const menuClickedItem = lineItem4.textContent; // "Product D"
  console.log('menuClickedItem', menuClickedItem);

  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
    console.log(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    console.log(`Action: ${action}`);
    //xsetIsMenuOpen(false); // Close menu after action
  };

  return (
    <>
    {isLoading > 0 ? ( 
      isLoading>1 ? <h1>Gathering Device configurations... </h1> : <h1>Gathering your Device Status.</h1>
    ) : (    

    <ThemeProvider theme={theme}>
      <Card sx={{ maxWidth: 480, backgroundColor: "lightgrey"}} variant="outlined" >
        <CardHeader
          title = {device_config['name']}
          subheader = {device_config.mac}
        
          action={
            <>
            <IconButton 
              aria-label="settings" 
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
            <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button',
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {options.map((option) => (
                <MenuItem key={option} onClick={handleMenuItemClick}>
                  {option}
                </MenuItem>
              ))}
            </Menu>
            </>
          }
          />
  <Typography variant="h12" component="div">{JSON.stringify(mqttConnected)}</Typography>
        <CardContent>    
        <Typography variant="h9" component="div">{JSON.stringify(device_config)}</Typography>          
          <>
          { relays_io_list?.map(  (one_relay, counter) => (      
          <>
               <URelay key={`OneRelay${counter}`} io={one_relay} config={relays_config[counter]}  device={device_config} position={counter}/>
          </>
           ))}
</>

      {gpios_list && gpios_list.map((one_gpio) => (
        <Button
            key={"gpio" + one_gpio.index}
            variant="contained"
            endIcon={<RadioButtonUncheckedIcon />}
            color={one_gpio.state===0 ? "green" : "red" }
            size="small"
          >
            {one_gpio.name}
          </Button>
        ))}


      <Typography variant="h12" component="div">{JSON.stringify(mySwitchIO)}</Typography>
      <Typography variant="h12" component="div">{JSON.stringify(messageHistory)}</Typography>
          </CardContent>
      </Card>
    </ThemeProvider>
         )
         }
    </>
  )
}
